import { Component } from '@angular/core';
import { AutoScraperBackendService } from './auto-scraper-backend.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'bruchpilot';

  constructor(public data: AutoScraperBackendService) {}
}
